// Real RELATABLE brand assets uploaded by the studio.
export const LOGO = {
  full_white: "https://customer-assets.emergentagent.com/job_brand-cinema-8/artifacts/3j3f8ta6_RelatableLogo-White.png",
  full_blue:  "https://customer-assets.emergentagent.com/job_brand-cinema-8/artifacts/46qmdcej_RelatableLogo-Blue.png",
  full_black: "https://customer-assets.emergentagent.com/job_brand-cinema-8/artifacts/94c3ddg2_RelatableLogo-Black.png",
  type_white: "https://customer-assets.emergentagent.com/job_brand-cinema-8/artifacts/r9c3geez_Typelogo-White.png",
  type_blue:  "https://customer-assets.emergentagent.com/job_brand-cinema-8/artifacts/97n8r0es_Typelogo-Blue.png",
};
